import {createContext} from "react";
import {IFirebaseContext} from "./models/IFirebaseContext.ts";

export const FirebaseContext = createContext<IFirebaseContext>({});